import React from "react";
import { Link } from "react-router-dom";
import { useTenant } from "../../../app/providers/TenantProvider";
import { useSaasSubscription } from "../hooks/useSaasSubscription";

/**
 * SubscriptionBanner — permanent countdown / frozen notice for the OWNER.
 *
 * - PAST_DUE: trial/period ended without a confirmed payment → warning banner
 *   with the days-left countdown (`days_until_freeze`) before the academy freezes.
 * - FROZEN: countdown elapsed → danger banner; operations are blocked server-side.
 * - Any other status (TRIAL/ACTIVE): renders nothing.
 *
 * Mount only for owners: the subscription endpoint is owner-scoped.
 */
function SubscriptionBanner() {
  const { slug } = useTenant();
  const { data: sub } = useSaasSubscription();
  const status = sub?.status;

  if (status !== "PAST_DUE" && status !== "FROZEN") return null;

  const planLink = `/${slug}/app/plan`;

  if (status === "FROZEN") {
    return (
      <div
        className="alert alert-danger border-0 rounded-0 mb-0 d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2"
        role="alert"
      >
        <span>
          <i className="mdi mdi-lock-alert me-2" aria-hidden="true" />
          <strong>Tu academia está congelada</strong> por falta de pago. No
          podrás registrar operaciones hasta regularizar el pago.
        </span>
        <Link to={planLink} className="btn btn-sm btn-light fw-semibold flex-shrink-0">
          Ver mi plan
        </Link>
      </div>
    );
  }

  // PAST_DUE — cuenta regresiva
  const days = sub?.days_until_freeze;
  return (
    <div
      className="alert alert-warning border-0 rounded-0 mb-0 d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2"
      role="alert"
    >
      <span>
        <i className="mdi mdi-clock-alert-outline me-2" aria-hidden="true" />
        Tu período terminó.{" "}
        {days == null ? (
          "Regulariza tu pago para continuar."
        ) : days > 0 ? (
          <>
            Tienes <strong>{days} día{days === 1 ? "" : "s"}</strong> para
            registrar tu pago antes de que tu academia se congele.
          </>
        ) : (
          "Tu academia se congelará hoy si no registramos tu pago."
        )}
      </span>
      <Link to={planLink} className="btn btn-sm btn-dark fw-semibold flex-shrink-0">
        Pagar / ver plan
      </Link>
    </div>
  );
}

export { SubscriptionBanner };
